import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function ConsPayReport(props) {
    const urlParams = new URLSearchParams(window.location.search);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [addedby, setAddedby] = useState({username: ''});
    const [mode, setMode] = useState({mode: ''});
    const [rows, setRows] = useState([]);
    const [userData, setUserData] = useState([]);
    const [combinedData, setcombinedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    const handleUser = (event) => {
        setAddedby({
            ...addedby,
            username: event.target.value
        });
    };
    const handleMode = (event) => {
        setMode({
            ...mode,
            mode: event.target.value
        });
    };
    useEffect(() => {
        try {
            axios.get(`${baseUrl}cons-search/`)
                .then(function (response) {
                    setUserData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        fetchData();
    }, [startDate, endDate, addedby, mode]);
    useEffect(() => {
        if (combinedData.length > 0) {
            setRows(combinedData);
        }
    }, [combinedData]);
    function fetchData() {
        setIsLoading(true);
        const startDateString = startDate ? startDate.toISOString().substring(0, 10) : '';
        const endDateString = endDate ? endDate.toISOString().substring(0, 10) : '';
        const url = `${baseUrl}cons-pay-report/?start_date=${startDateString}&end_date=${endDateString}&addedby=${addedby.username}&mode=${mode.mode}&status=1`;
        axios.get(url)
            .then(response => {
                setcombinedData(response.data);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }
    const columns = [
        {field: 'pay_on', headerName: 'Date', width: 120},
        {field: 'appt__appt_id', headerName: 'Appointment ID', width: 200},
        {field: 'cons__consultant', headerName: 'Consultant', width: 200},
        {field: 'pay_type', headerName: 'Pay Type', width: 110},
        {
            field: 'pay_id', headerName: 'Receipt',
            width: 120
        },
        {field: 'pay_amount', headerName: 'Pay Amount', width: 150},
        {field: 'pay_by', headerName: 'Pay by', width: 100},
    ];
    const getTotal = (rows, field) => {
        return rows.reduce((totals, row) => {
            const value = parseFloat(row[field]);
            if (!isNaN(value)) {
                return totals + value;
            }
            return totals;
        }, 0);
    };
    const Footer = ({rows}) => {
        const totalInvoicedAmount = getTotal(rows, 'pay_amount');
        return (
            <div style={{display: 'flex', justifyContent: 'space-evenly', padding: '8px'}}>
                <div>Total</div>
                <div>{totalInvoicedAmount?.toFixed(2)}</div>
            </div>
        );
    };
    const today = new Date();
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> Consultant Pay Report</h3>
            <div className="row">
                <div className="col-md-6">
                    <label htmlFor="user" className="form-label">Select Date</label>

                    <div className="date-filter-container">
                        <DatePicker
                            selected={startDate}
                            onChange={handleStartDateChange}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText="From Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />

                        <DatePicker
                            selected={endDate}
                            onChange={handleEndDateChange}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            placeholderText="To Date"
                            dateFormat="dd/MM/yyyy"
                            showMonthDropdown
                            showYearDropdown
                            className="date-picker-input"
                        />
                    </div>
                </div>

                <div className="col-md-3">

                    <label htmlFor="user" className="form-label">Search by Consultant</label>
                    <select name="user" id="username" value={addedby.user} className="form-control"
                            onChange={(event) => handleUser(event)}>
                        <option value="">Select Consultant</option>
                        {userData.map((User, index) => (
                            <option key={index} value={User.id}>{User.consultant}</option>
                        ))}
                    </select>
                </div>

                <div className="col-md-3">

                    <label htmlFor="mode" className="form-label">Search by Sales Mode</label>
                    <select name="mode" id="mode" value={mode.mode} className="form-control"
                            onChange={(event) => handleMode(event)}>
                        <option value="">Select Pay Mode</option>
                        <option value="Cash">Cash</option>
                        <option value="Cheque">Cheque</option>
                        <option value="Others">Others</option>
                    </select>

                </div>
            </div>

            {!isLoading && combinedData.length > 0 ? (
                <div style={{height: "100%", width: "100%"}}>
                    <DataGrid className="mt-4"
                              sx={{
                                  boxShadow: 4,
                                  border: 4,
                                  borderColor: 'primary.light',
                                  '& .MuiDataGrid-cell:hover': {
                                      color: 'primary.main',
                                  },
                              }}
                              rows={rows}
                              columns={columns}
                              pageSize={10}
                              slots={{
                                  toolbar: GridToolbar,
                              }}
                              autoHeight
                    />
                    <table className="mt-4" style={{width: '100%', borderCollapse: 'collapse'}}>
                        <tfoot>
                        <Footer rows={rows}/>
                        </tfoot>
                    </table>
                </div>
            ) : (
                <></>
            )}
        </section>
    )
}
export default ConsPayReport;
